/**
 * Type of MarginRequirementReport.
 * tag: 1638
 * @readonly
 * @enum {number} (int)
 */
export enum MarginReqmtRptType {
  /** Summary */
  Summary = 0,
  /** Detail */
  Detail = 1,
  /** Excess/Deficit */
  ExcessDeficit = 2,
}
